<template>
  <div >
    <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
      <el-radio-group v-model="activeName" style="padding: 10px 5px" @change="handleChange" size="medium">
        <!--      <el-radio-button v-permission="'ensure_income_confirm__list'" label="全案保量" name="order"/>-->
        <!--      <el-radio-button v-permission="'business_income_confirm__list'" label="商务收入" name="regular"/>-->
        <el-radio-button v-permission="'ensure_income_confirm'" label="全案保量" name="order"/>
        <el-radio-button v-permission="'business_income_confirm'" label="商务收入" name="regular"/>
      </el-radio-group>
      <div>
        <el-tag style="border-radius: 50%" effect="plain">助</el-tag>
      </div>

    </div>
    <div>
      <income-ensure v-if="activeName === '全案保量'"></income-ensure>
      <income-business v-if="activeName === '商务收入'"></income-business>
    </div>
  </div>
</template>

<script>
import incomeEnsure from './incomeEnsure.vue'
import incomeBusiness from './incomeBusiness.vue'

const permissions = localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')).value : {}
const {ensure_income__list, business_income__list} = permissions

export default {
  name: "index",
  data() {
    return {
      activeName: '全案保量',
    }
  },
  components: {
    incomeEnsure,
    incomeBusiness,
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleChange(tabName) {
      // eslint-disable-next-line no-console
      // console.log(this.activeName)
      // const pathName = this.$route.name
      // const query = {...this.$route.query, ...{tabName: tabName}}
      // console.log(query)
      // this.$router.replace(pathName, query)
    }
  },
  created() {
    const tabRange = []
    if (ensure_income__list) {
      // this.activeName = '全案保量'
      tabRange.push('全案保量')
    }
    if (business_income__list) {
      // this.activeName = '商务收入'
      tabRange.push('商务收入')
    }
    // eslint-disable-next-line no-console
    const query = this.$route.query
    // eslint-disable-next-line no-console
    if (query.tab) {
      if (tabRange.indexOf(query.tab) > -1) {
        this.activeName = query.tab
      }
    } else {
      this.activeName = tabRange[0] || '全案保量'
    }


  }
}
</script>

<style scoped></style>
